import React from 'react'
import { Input, Form } from 'semantic-ui-react'

export const MyInput = ({
    field,
    form: { touched, errors },
    ...props
}) => (
        <>
            <Form.Input

                {...field}
                {...props}
            />
            {/* <Input {...field} {...props} />
            {touched[field.name] && errors[field.name] && <small>{errors[field.name]}</small>} */}
        </>
    )
export const MyNormalInput = ({
    field,
    form: { touched, errors },
    ...props
}) => (
        <>
            <Input

                {...field}
                {...props}
            />
            {/* <Input {...field} {...props} />
                {touched[field.name] && errors[field.name] && <small>{errors[field.name]}</small>} */}
        </>
    )

export const MyCheckBox = ({
    field,
    form: { touched, errors },
    ...props
}) => (
        <>
            <Form.Checkbox {...field} {...props} />
        </>
    )
export const MyTextArea = ({
    field,
    form: { touched, errors },
    ...props
}) => (
        <>
            <Form.TextArea {...field} {...props} />
        </>
    )
export const MySelect = ({
    field,
    form: { touched, errors },
    ...props
}) => (
        <>
            <Form.Select {...field} {...props} />
        </>
    )
